<template>
  <el-form label-position="left" ref="ruleForm" :model="formData" @validate="handleValidate" :rules="rules" label-width="120px" >
    <formGroup>广告组</formGroup>
    <formGroup :level="2">广告目的及形式</formGroup>
    <el-form-item label="推广目的" required>
      <span style="color: #333333;font-size:12px">应用下载</span>
      <!-- <el-checkbox-group size="mini" v-model="formData.aim">
        <el-checkbox-button 
          v-for="item in aimList" 
          :label="item.value" :key="item.value">
          {{item.label}}
        </el-checkbox-button>
      </el-checkbox-group> -->
    </el-form-item>
    <el-form-item label="投放版位" prop="position" >
      <el-checkbox-group size="mini" v-model="formData.position" >
        <el-checkbox-button 
          v-for="item in positionList" 
          @change="(data)=>handlePositionChange(data,item)"
          :label="item.value" :key="item.value">
          {{item.label}}
        </el-checkbox-button>
      </el-checkbox-group>
    </el-form-item>
    <formGroup :level="2">广告投放方式</formGroup>
    <el-form-item label="广告形式" required>
      <span style="color: #333333;font-size:12px">普通广告</span>
      <!-- <el-radio-group size="mini" v-model="formData.way">
        <el-radio-button 
          v-for="item in wayList" 
          :label="item.value" :key="item.value">
          {{item.label}}
        </el-radio-button>
      </el-radio-group> -->
    </el-form-item>
     <el-form-item label="关联商品品类"  required>
      <span style="color: #333333;font-size:12px">关闭</span>
      <!-- <el-switch
        v-model="formData.category"
      >
      </el-switch> -->
    </el-form-item>
    <formGroup :level="2">定向</formGroup>
    <el-form-item label="定向人群" >
      <ESelect class="input-width" 
        clearable 
        reserve-keyword 
        filterable 
        remote
        :remote-method="(v)=>dirUserRemoteMethod('dirUserKeyword',v)"
        multiple 
        v-model="formData.directCrowd" 
        :placeholder="account?'输入人群包名称或ID搜索或下拉选择人群包':'请先选择目标账户'"
        @focus="dirUserKeyword=''"
      >
        <div class="check_all" v-if="dirUserList.length">
          <span @click="handleCheckAll(dirUserList, formData.directCrowd, true )">全选</span>
          <span @click="handleCheckAll(dirUserList, formData.directCrowd, false )">取消全选</span>
        </div>
        <el-option 
          v-for="item in dirUserList" 
          :key="item.dmp_id"
          :disabled="item.disabled"
          :label="item.package_name_fmt"
          :value="item.dmp_id"
        />
      </ESelect>
       <UpdateTimeButton 
          type="primary" 
          plain 
          style="margin-left:16px"
          :date="updateTime"
          :disabled="!account"
          @click="()=>$emit('updateUserList', (t)=>updateTime=t)"
       />
    </el-form-item>
    <el-form-item label="排除人群" >
      <ESelect 
        class="input-width" 
        filterable 
        reserve-keyword 
        clearable 
        multiple 
        v-model="formData.excludeCrowd" 
        :placeholder="account?'输入人群包名称或ID搜索或下拉选择人群包':'请先选择目标账户'"
        :remote-method="(v)=>dirUserRemoteMethod('excUserKeyword', v)"
        @focus="excUserKeyword=''"
      >
        <div class="check_all" v-if="dirUserList.length">
          <span @click="handleCheckAll(excUserList, formData.excludeCrowd, true )">全选</span>
          <span @click="handleCheckAll(excUserList, formData.excludeCrowd, false )">取消全选</span>
        </div>
        <el-option 
          v-for="item in excUserList" 
          :key="item.dmp_id"
          :disabled="item.disabled"
          :label="item.package_name_fmt"
          :value="item.dmp_id"
        />
      </ESelect>
    </el-form-item>
    <el-form-item label="应用用户" prop="user">
      <el-radio-group size="mini" v-model="formData.user">
        <el-radio-button 
          v-for="item in userList" 
          :label="item.value" :key="item.value">
          {{item.label}}
        </el-radio-button>
      </el-radio-group>
      <div v-if="userListConfig[formData.user]" class="el-form-item__error">{{userListConfig[formData.user]}}</div>
    </el-form-item>
    <formGroup :level="2">名称</formGroup>
    <el-form-item label="广告组名称" prop="name">
      <inputSelect
         placeholder="您可输入或选择通配符动态生成名称，但最终结果名称不可超过60字" 
          v-model="formData.name"
          input-style="width:600px"
          @change="(value)=>$emit('update:adgroupName', value)"
          @tab-click="data=>data.cb&&data.cb()"
          :list="nameList"
      />
    </el-form-item>
     <el-form-item label="状态" required>
      <el-switch v-model="formData.state"/>
    </el-form-item>
  </el-form>
</template>

<script>
import formGroup from './formGroup.vue'
import inputSelect from './inputSelect.vue'
import { validEmoji } from '@/utils/validate'
import UpdateTimeButton from '@/components/UpdateTimeButton'
export default {
  components: { formGroup, inputSelect, UpdateTimeButton },
   inject: ['getOption', 'validFormItem', 'nameCb'],
   props: [ 'campaignType', 'displayType', 'userPackageDataList' ,'account'],
  data() {
    const validateName = (rule, value, callback)=> {
      if (validEmoji(value)) {
        callback(new Error('不可包含表情'))
      }else {
        callback()
      }
    }
    return {
      dirUserKeyword: '',
      excUserKeyword: '',
      updateTime: 0,//限制更新的时间
      product_type_list:[],
      display_type_list: [],
      userList: [],
      wayList: [],
      nameList: [],
      formData: {
        aim: ['2'],//推广目的 应用下载
        position: [],//投放版位
        way: '',//广告形式
        category: false,//关联商品品类
        directCrowd: [],//定向人群
        excludeCrowd: [],//排除人群
        user: '',//应用用户
        name: '{项目名称}-{版位}-{跟踪类型}-{转化类型}-{创建日期}-{任务号-顺序号}-wk',//
        state: true,//状态
      },
      rules: {
        position: [
          { required: true, message: '请选择投放版位', trigger: 'change' }
        ],
        user: [
          { required: true, message: '请选择应用用户', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入或选择通配符', trigger: 'change' },
          { validator: validateName, message:'不可输入表情', trigger: 'blur' },
        ],
      }
    }
  },
  computed: {
    // 推广目的
    aimList(){
      const ids = this.campaignType.map(v=>v.param_id);
      const data = this.product_type_list.filter(v=>ids.includes(v.pid))
      .reduce((pre, item)=>{
        pre[item.param_id] = item;
        return pre
      },{});
      return Object.values(data).map(v=> {
        return {
          label: v.param_name,
          value: v.param_id,
          ...v
        }
      })
    },
    // 投放版位
    positionList() {
      const ids = this.campaignType.map(v=>v.param_id).map(v=> {
        return this.formData.aim.map(id=> {
          return `${v}_${id}`
        })
      }).reduce((pre, item)=> {
        return [...pre, ...item]
      },[]);
      const arr = [];
      const ls = [];
      this.display_type_list.filter(v=>ids.includes(v.pid)).map(v=> {
        if (!arr.includes(v.param_id)) {
          arr.push(v.param_id);
          ls.push({
            ...v,
            label: v.param_name,
            value: v.param_id,
          })
        }
      });
      return ls;
    },
    // 定向人群
    dirUserList() {
      // this.directCrowd excludeCrowd
      const { excludeCrowd } = this.formData
      return this.userPackageDataList.map(v=> {
        return {
          ...v,
          disabled: excludeCrowd.includes(v.dmp_id)
        }
      }).sort((a,b)=>{
        return a.disabled - b.disabled
      }).filter(v=> {
        return v.package_name_fmt.indexOf(this.dirUserKeyword)>-1
      })
    },
    // 排除人群
    excUserList() {
      const { directCrowd } = this.formData
      return this.userPackageDataList.map(v=> {
        return {
          ...v,
          disabled: directCrowd.includes(v.dmp_id)
        }
      }).sort((a,b)=>{
        return a.disabled - b.disabled
      }).filter(v=> {
        return v.package_name_fmt.indexOf(this.excUserKeyword)>-1
      })
    },
    userListConfig() {
      return this.userList.reduce((pre, item)=>{
        pre[item.param_id] = item.config;
        return pre;
      }, {})
    }
  },
  watch: {
    aimList(n) {
      const aimIds = [];
      n.map(v=> {
        if (v.required) {
          aimIds.push(v.param_id);
        }
      });
      // this.formData.aim = aimIds;
    },
    positionList(n, o) {
      const list = [],positionIds=[];
      const noCheckIds = o.filter(v=>!this.formData.position.includes(v.param_id)).map(v=>v.param_id)
      n.map(v=> {
        if (v.required&&!noCheckIds.includes(v.param_id)) {
          positionIds.push(v.param_id);
          list.push(v)
        }
      });
      this.formData.position = positionIds
      this.$emit('update:displayType', [...list])
    },
    account() {
      this.formData.directCrowd = []
      this.formData.excludeCrowd = []
    }
  },
  created() {
    const { product_type, display_type, ad_prod_type, installation, wildcard_adgroup_name } = this.getOption();
    this.product_type_list = product_type;
    this.display_type_list = display_type;
    this.wayList=ad_prod_type.map(v=> {
      if (v.required) {
        this.formData.way = v.param_id
      }
      return {
        ...v,
        label: v.param_name,
        value: v.param_id,
      }
    })
    this.userList = installation.map(v=> {
      if (v.required) {
        this.formData.user = v.param_id
      }
      return {
        ...v,
        label: v.param_name,
        value: v.param_id,
      }
    });
    this.nameList = wildcard_adgroup_name.map(v=> {
      this.nameCb(v);
      return {
         ...v,
        label: v.param_name,
        value: v.param_name,
      }
    });
    this.$emit('update:adgroupName', this.formData.name)
  },
  methods: {
    // 全选和取消全选
    handleCheckAll(list, data, check) {
      if (check) {
        data.push(...list.filter(v=>!v.disabled&&!data.includes(v.dmp_id)).map(v=>v.dmp_id))
      }else{
        list.forEach(v=> {
          const i = data.indexOf(v.dmp_id);
          if (i>-1) {
            data.splice(i, 1)
          }
        })
      }
    },
    dirUserRemoteMethod(key, value) {
      this[key] = value
    },
     handleValidate(key, valid, info) {
      const data = {
        position: '广告组-投放版位',
        user: '广告组-应用用户',
        name: '广告组-广告组名称',
      };
      if (!valid) {
        this.validFormItem(`${data[key]}：${info}`)
      }
    },
    handlePositionChange(data, item) {
      if (!data) {
         this.$bus.$emit('hasAddDate',[item], (b)=> {
          if (b) {
            this.$confirm('取消该版位后已经录入的相关信息（版位、转化出价、创意组）将同步删除，确认要取消吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.updateDisplayType()
            }).catch(() => {
              this.formData.position.push(item.value)
            });
          }else {
            this.updateDisplayType()
          }
         })
      }else {
        this.updateDisplayType()
      }
    },
    updateDisplayType() {
      const list = this.positionList.filter(v=> this.formData.position.includes(v.param_id));
      this.$emit('update:displayType', [...list]);
    },
     // 获取表单数据
    async validateFn() {
        const valid = await this.$refs.ruleForm.validate();
        if (valid) {
          return {...this.formData}
        }
    },
    setFormData(data) {
      let list = [... data.position]
      let directCrowd = [... data.directCrowd]
      let excludeCrowd = [... data.excludeCrowd]
      
       this.formData  = data;
       this.$emit('update:adgroupName', data.name)
       setTimeout(()=> {
        this.formData.position  = list;
        this.formData.directCrowd = directCrowd
        this.formData.excludeCrowd = excludeCrowd
        this.updateDisplayType()
       },1000)
    },
  }
}
</script>

<style lang="scss" scoped>
.input-width {
  width: 600px;
}
.check_all {
  padding: 8px 20px;
  span {
    margin-right: 12px;
    color: #409EFF;
    cursor: pointer;
  }
}
</style>